var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"73058aec4b0486d9afdb7cb2ae33b910f231b5f3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hem-com@hem-design-studio"]={id:"73058aec4b0486d9afdb7cb2ae33b910f231b5f3"};
      